import { IconButton } from '@mui/material';
import DocumentsIcon from '@mui/icons-material/DescriptionTwoTone';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { setModalSearchParameters } from '@hooks/useModalParams';
import { ConsignmentTab } from '@/ConsignmentDetails/types';

import styles from './ApplicationLink.module.css';

interface DocumentsLinkProps {
  leg: DispatchLeg;
}

/**
 * Component for rendering a Manage Document link.
 */
export default function DocumentsLink({ leg }: DocumentsLinkProps) {
  const handleBtnClick = () => {
    setModalSearchParameters({
      form: 'consignmentDetails',
      formId: String(leg.csnId),
      tab: ConsignmentTab[ConsignmentTab.Documents]
    });
  };

  return (
    <IconButton
      className={styles['icon-btn']}
      onClick={handleBtnClick}>
      <DocumentsIcon fontSize='inherit' />
    </IconButton>
  );
}
